import type { SocketOptions } from 'engine.io-client';
import type { ManagerOptions } from 'socket.io-client';

export const socketConfig: Partial<SocketOptions & ManagerOptions> = {
  transports: ['websocket', 'polling'],
  autoConnect: false,
  withCredentials: true,
  path: '/socket.io',
};
